import React from 'react';
import { Box, Skeleton, Stack } from '@mui/material';
import styles from './DataProducts.module.scss';

const PlaceholderContent = () => {
  return (
    <Box className={styles.cardLoader}>
      <Stack padding="16px">
        <Skeleton
          variant="rounded"
          animation="wave"
          width="90%"
          height="1.4rem"
          style={{ marginBottom: 'var(--spacing-md)' }}
        />

        <Skeleton
          variant="rounded"
          animation="wave"
          className={styles.placeholderLine}
          width="85%"
          height="14px"
        />

        <Stack marginTop="32px">
          {new Array(4).fill(0).map((el, index) => (
            <Stack key={index} height="21px" direction="row" gap="12px" alignItems="center">
              <Skeleton variant="rounded" animation="wave" height="14px" width="20%" />

              <Skeleton variant="rounded" animation="wave" height="14px" width="20%" />
            </Stack>
          ))}
        </Stack>
      </Stack>
    </Box>
  );
};

export default PlaceholderContent;
